import { Component } from 'react';

export class SilentErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Reset the error state to continue rendering the children
    return { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    // Optionally log the error silently
    console.debug('Caught and ignored error:', error);
  }

  render() {
    // Always render children, regardless of error state
    return this.props.children;
  }
}